import type { EddStatus, EddDocumentType } from "@/core/compliance/entities/EddCase";

const base = "/compliance/edd/cases";

/** Taille large = fetch-all (petits volumes ; tri + pagination côté client ensuite). */
const FETCH_ALL = 500;

const eddEndpoints = {
  // GET /compliance/edd/cases requires the `status` query param (backend has no list-all).
  // Réponse paginée `{ items, totalElements }` ; on récupère tout (size large) pour paginer côté client.
  casesByStatus: (status: EddStatus) =>
    `${base}?status=${status}&page=0&size=${FETCH_ALL}`,
  assigned: (analyst: string) =>
    `${base}/assigned/${encodeURIComponent(analyst)}?page=0&size=${FETCH_ALL}`,
  case: (caseId: string) => `${base}/${caseId}`,
  documents: (caseId: string) => `${base}/${caseId}/documents`,
  // POST addDocument: `type` (and optional `comment`) are query params; only the
  // file goes in the multipart body.
  addDocument: (caseId: string, type: EddDocumentType, comment?: string) =>
    `${base}/${caseId}/documents?type=${type}` +
    (comment ? `&comment=${encodeURIComponent(comment)}` : ""),
  history: (caseId: string) => `${base}/${caseId}/history`,
  download: (caseId: string, documentId: string, inline: boolean) =>
    `${base}/${caseId}/documents/${documentId}/download${inline ? "?inline=true" : ""}`,
  // POST — déclenche l'envoi d'un OTP MFA à l'email du décideur avant la décision 4-yeux (#24704).
  mfaChallenge: (caseId: string) => `${base}/${caseId}/decision/mfa-challenge`,
  submitL1: (caseId: string) => `${base}/${caseId}/submit-l1`,
  assign: (caseId: string) => `${base}/${caseId}/assign`,
  suspend: (caseId: string) => `${base}/${caseId}/suspend`,
  resume: (caseId: string) => `${base}/${caseId}/resume`,
  approveL1: (caseId: string) => `${base}/${caseId}/approve-l1`,
  approveL2: (caseId: string) => `${base}/${caseId}/approve-l2`,
  reject: (caseId: string) => `${base}/${caseId}/reject`,
} as const;

export default eddEndpoints;
